import type { NavigationWidgetDataFormType } from '../type/navigation-widget.type';

import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

export const navigationWidgetFormGroup = (): FormGroup<NavigationWidgetDataFormType> =>
    new FormGroup({
        menuList: new FormArray([]),
        textColor: new FormControl(null, [Validators.required]),
        submenuTextColor: new FormControl(null, [Validators.required]),
        fontSize: new FormControl(null, [Validators.required]),
        submenuFontSize: new FormControl(null, [Validators.required]),
        menuItemIndent: new FormControl(null, [Validators.required]),
        horizontalPosition: new FormControl(null, [Validators.required]),
        fontStyle: new FormArray([]),
        submenuFontStyle: new FormArray([]),
        submenuListBackground: new FormControl(null, [Validators.required]),
        layoutDirection: new FormControl(null, [Validators.required]),
        hoverEffects: new FormGroup({
            type: new FormControl(null, [Validators.required]),
            color: new FormControl(null),
            transparency: new FormControl(null),
            lineType: new FormControl(null),
            lineWidth: new FormControl(null),
            animationType: new FormControl(null),
        }),
    });
